module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      userAvatar: _vm.$store.state.user.cover_photo
    },
    style: ({
      'background': 'url(' + _vm.$store.state.user.cover_photo + ') center center no-repeat no-repeat',
      'background-size': 'cover',
      'position': 'relative'
    })
  }, [(_vm.$store.state.user.cover_photo) ? _c('div', {
    staticClass: "blackGradient"
  }) : _vm._e(), (_vm.$store.state.user.scope) ? _c('mu-list', [_c('mu-list-item', {
    attrs: {
      "title": _vm.upperFirstChar,
      "describeText": _vm.$store.state.user.scope.diabetes_type.diabetes_type ? _vm.$store.state.user.scope.diabetes_type.diabetes_type : null,
      "disabled": "disabled"
    }
  }, [(!_vm.$store.state.user.scope.profile_large) ? _c('mu-avatar', {
    staticClass: "blue",
    attrs: {
      "slot": "left",
      "src": _vm.$store.state.user.scope.profile_large,
      "color": "white",
      "backgroundColor": "grey"
    },
    slot: "left"
  }, [_vm._v(_vm._s(_vm.upperTwoInitials))]) : _c('mu-avatar', {
    attrs: {
      "slot": "left",
      "src": _vm.$store.state.user.scope.profile_large,
      "color": "white",
      "backgroundColor": "grey"
    },
    slot: "left"
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e848e86","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserAvatar/UserAvatar.vue
// module id = 3743
// module chunks = 1